import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertUserRoleRequest } from './types/upsert-user-role-request.type';

/**
 * Assigns a role directly to a user.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the user.
 * @param body - The role grant, including the effective and expiration dates.
 * @returns OperationResult (no payload).
 */
export const upsertUserRole = async (instance: KyInstance, uid: string, body: UpsertUserRoleRequest) => {
  try {
    return await instance
      .post<OperationResult>(formatString(Uri.users.roles, uid), {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
